import { render, staticRenderFns } from "./AddCertificate.vue?vue&type=template&id=46400ed6&scoped=true&"
import script from "./AddCertificate.vue?vue&type=script&lang=js&"
export * from "./AddCertificate.vue?vue&type=script&lang=js&"
import style0 from "./AddCertificate.vue?vue&type=style&index=0&id=46400ed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46400ed6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSwitch,VTextField})
